import React, { useState } from "react";
import { useEffect } from "react";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import { Link, useNavigate } from "react-router-dom";
import NoContent from "../../../assets/vectors/NoContent.webp";
import { GetMyNotices } from "../../../services/NoticeService";
import { Button } from "@mui/material";
import { GetCompanies } from "../../../services/CompanyService";
import { useSelector } from "react-redux";
import { getMyProfile } from "../../../features/profile/profileSlice";
import { Any } from "@grpc/grpc-js/build/src/generated/google/protobuf/Any";
import { GetRolesList } from "../../../services/RoleService";
const RolesList = () => {
  const [data, setData] = useState([]);
  const myProfile = useSelector(getMyProfile);
  const navigate = useNavigate();

  useEffect(() => {
    GetDataAsync();
  }, []);

  const GetDataAsync = async () => {
    try {
      const data = await GetRolesList();
      console.log(data);

      setData(data.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="container">
      <Button
        onClick={() => {
          navigate("/NewRole");
        }}
        className="mt-3"
        color="success"
        variant="outlined"
        endIcon={<InventoryOutlinedIcon />}
      >
        <span className="px-2">تعریف نقش جدید</span>
      </Button>
      <hr className="mt-2" />
      {data.length > 0 ? (
        <>
          <div className=" mt-2 mb-5" style={{ textAlign: "center" }}>
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">نقش</th>

                  <th scope="col"> ویرایش </th>
                  <th scope="col"> تعیین سطح دسترسی </th>
                </tr>
              </thead>
              <tbody>
                {data.map((p: any) => {
                  return (
                    <tr key={p.id}>
                      <td>
                        {p.name}/{p.localizedName}
                      </td>

                      <td>
                        <Button className="px-3 m-1">
                          <i className="fa fa-pencil" aria-hidden="true"></i>
                        </Button>
                      </td>
                      <td>
                        <Link to="/editAccess ">
                          <Button className="px-3 m-1">
                            <i className="fa fa-pencil" aria-hidden="true"></i>
                          </Button>
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>{" "}
        </>
      ) : (
        <>
          <div className="mt-2 mb-5" style={{ textAlign: "center" }}>
            <div>
              <img src={NoContent} alt="شما تاکنون نقشی تعریف نکرده اید" />
            </div>
            <div>
              <b> شما تاکنون نقشی تعریف نکرده اید!</b>
            </div>
            <br />
          </div>
        </>
      )}

      <hr />
    </div>
  );
};
export default RolesList;
